<template>
  <v-container grid-list-lg>
    <div class="head-title mb-4">
      <h1 class="display-1">Mes entreprises</h1>
    </div>
    <v-layout>
      <v-tabs v-model="activeTab" slider-color="primary" class="full-w">
        <v-tab ripple v-if="getUserRole.name !== 'Agent'">
          mes référés
        </v-tab>
        <v-tab ripple v-if="getUserRole.name !== 'Agent'">
          référées par mes agents <!-- ajouter  la query dans l'url actions?entreprises_agent -->
        </v-tab>
        <v-tab-item class="rel">
          <HeaderTable @updateSearch="updateSearch">
            <v-data-table :headers="headers" :loading="loading" :items="getEntreprises" :search="search" no-results-text="Votre recherche n'a retourné aucun resultat" footer-props.items-per-page-text="Éléments par page" no-data-text="Aucune donnée disponible.">
              <template slot="items" slot-scope="props">
                <td>{{ props.item.nom }}</td>
                <td>{{ props.item.taux_commission }}</td>
                <td>{{ props.item.fondation ? 'Oui' : '' }}</td>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>
          </HeaderTable>
          <div class="floating-btn abs d-flex justify-content-end">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="modal = true" right dark fab top color="primary">
                <v-icon>add</v-icon>
              </v-btn>
              </template>
              <span>Ajouter une entreprise</span>
            </v-tooltip>
          </div>
        </v-tab-item>
        <v-tab-item>
          <HeaderTable @updateSearch="updateSearch">
            <v-data-table :headers="headers" :items="items" :loading="loading" :search="search" no-results-text="Votre recherche n'a retourné aucun resultat" footer-props.items-per-page-text="Éléments par page" no-data-text="Aucune donnée disponible.">
              <template slot="items" slot-scope="props">
                <td>{{ props.item.id }}</td>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>
          </HeaderTable>
        </v-tab-item>
      </v-tabs>

    </v-layout>
    <v-layout row wrap v-if="getUserRole.name === 'Admin'" class="mt-3">
      <v-flex xs12 sm6>
        <v-alert :value="true" color="info" icon="info" outlined>Total Commission : 50.00</v-alert>
      </v-flex>
      <v-flex xs12 sm6>
        <v-alert :value="true" color="red" icon="attach_money" outlined>Total Payé: -350.00</v-alert>
      </v-flex>
      <v-flex xs12>
        <v-alert :value="true" color="warning" icon="warning" outlined>Chaque commission est calculée à la date actuelle : 2018-12-23 00:59:41 (QC)</v-alert>
      </v-flex>
    </v-layout>
    <v-dialog v-model="modal" max-width="600px">
      <v-card>
        <v-card-title class="title-dialog">
            <v-icon color="primary" class="mr-2">{{ bankIcon }}</v-icon>
            <span> Ajouter une entreprise</span>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <form v-if="(getEntreprisesOptions && getEntreprisesOptions.activites)" @input="isValid">
            <v-container grid-list-lg>
              <v-layout row wrap>
                <v-flex sm6>
                  <v-text-field
                    v-model="formCompany.nom"
                    label="Nom"
                    v-validate="'required'"
                    data-vv-name="nom"
                    :error-messages="errors.collect('nom')"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex sm6>
                  <v-text-field
                    v-model="formCompany.taux_commission"
                    label="Taux de commission"
                    v-validate="'required'"
                    type="number"
                    data-vv-name="taux_commission"
                    :error-messages="errors.collect('taux_commission')"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex sm4>
                  <v-text-field
                    v-model="formCompany.url"
                    label="Url"
                    v-validate="'required'"
                    data-vv-name="url"
                    :error-messages="errors.collect('url')"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex sm4>
                  <v-select
                    v-model="formCompany.ville_id"
                    label="Ville ID"
                    :items="getEntreprisesOptions.villes.data"
                    item-text="nom"
                    item-value="uuid"
                    data-vv-name="ville_id"
                    required>
                  </v-select>
                </v-flex>
                <v-flex sm4>
                  <v-text-field
                    v-model="formCompany.civic"
                    label="Civic"
                    v-validate="'required'"
                    data-vv-name="civic"
                    :error-messages="errors.collect('civic')"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex sm4>
                  <v-text-field
                    v-model="formCompany.postal"
                    label="Code Postal"
                    v-validate="'required'"
                    data-vv-name="postal"
                    :error-messages="errors.collect('postal')"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex sm4>
                  <v-text-field
                    v-model="formCompany.rue"
                    label="Rue"
                    v-validate="'required'"
                    data-vv-name="rue"
                    :error-messages="errors.collect('rue')"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex sm4>
                  <v-text-field
                    v-model="formCompany.tel"
                    v-validate="'required'"
                    mask="phone"
                    clearable
                    required
                    type="tel"
                    :error-messages="errors.collect('tel')"
                    data-vv-name="tel"
                    label="Téléphone">
                  </v-text-field>
                </v-flex>
                <v-flex sm4>
                  <v-text-field
                    v-model="formCompany.email"
                    label="E-mail"
                    v-validate="'required|email'"
                    data-vv-name="email"
                    :error-messages="errors.collect('email')"
                    required>
                  </v-text-field>
                </v-flex>
                <v-flex sm4>
                  <v-select
                    v-model="formCompany.activite_id"
                    :items="getEntreprisesOptions.activites.data"
                    item-text="titre"
                    item-value="uuid"
                    label="Activite ID"
                    v-validate="'required'"
                    data-vv-name="activite_id"
                    :error-messages="errors.collect('activite_id')"
                    required>
                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        <!-- <v-autocomplete :items="getEntreprises" item-text="nom" item-value="nom" v-model="selectedCompany" label="Liste d'entreprises"></v-autocomplete> -->
        </v-card-text>
        <v-divider />
        <v-card-actions class="justify-center pb-3">
          <v-btn text color="danger" @click="modal = false">ANNULER</v-btn>
          <v-btn text color="primary" :disabled="valid" @click="addCompany">ENREGISTRER</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import HeaderTable from '@/components/helpers/HeaderTable.vue'
  import { mapGetters } from 'vuex'
  import { ENTREPRISES_REQUEST, ADD_ENTREPRISE_REQUEST, GET_ENTREPRISE_CREATE } from '@/store/actions/entreprises'
  import {$bus} from '../main'
  import { mdiBankPlus } from '@mdi/js';

  export default {
    name: 'MesEntreprises',
    $_veeValidate: {
      validator: 'new'
    },
    data: () => ({
      activeTab: 0,
      headers: [
        {
          text: 'Nom',
          align: 'left',
          sortable: true,
          value: 'nom',
        },
        {
          text: 'Taux commission',
          align: 'left',
          sortable: true,
          value: 'taux_commission',
        },
        {
          text: 'Fondation',
          align: 'left',
          sortable: true,
          value: 'fondation',
        }
      ],
      items: [],
      search: '',
      modal: false,
      selectedCompany: '',
      formCompany: {
        nom: '',
        taux_commission: '',
        url: '',
        ville_id: null,
        civic: '',
        postal: '',
        rue: '',
        tel: '',
        email: '',
        activite_id: null
      },
      valid: false,
      loading: false,
      loadingEntreprisesOptions: false,
      dictionary: {
        custom: {
          nom: {
            required: () => 'Veuillez renseigner un nom',
          },
          taux_commission: {
            required: () => 'Veuillez mettre un nombre valide',
          },
          url: {
            required: () => 'Veuillez entrer une url valide',
          },
          // ville_id: {
          //   required: () => 'Veuillez sélectionner une ville',
          // },
          civic: {
            required: () => 'Veuillez entrer un civic valide',
          },
          postal: {
            required: () => 'Veuillez entrer un code postal valide',
          },
          rue: {
            required: () => 'Veuillez entrer un nom de rue valide',
          },
          email: {
            required: () => 'Veuillez entrer un email valide',
          },
          activite_id: {
            required: () => 'Veuillez entrer un activite_id valide',
          }
        }
      },
      bankIcon: mdiBankPlus
    }),
    components: {
      HeaderTable
    },
    created () {
      this.loading = true
      this.$store.dispatch(ENTREPRISES_REQUEST).finally(() => {
        this.loading = false
      })
      this.$route.params.modal ? this.modal = true : this.modal = false
    },
    computed: {
      ...mapGetters (['getUserRole', 'getEntreprises', 'getEntreprisesOptions']),
      // valid () {
      //   console.log(this.$validator.errors.items.length)
      //   return this.$validator.errors.items.length ? false : true
      // }
    },
    methods: {
      isValid (valid) {
        if (valid) {
          this.$validator.validate().then( result => {
            this.valid = result
          })
        }
      },
      addCompany () {
        this.$validator.validate().then(result => {
          if (result) {
            this.$store.dispatch(ADD_ENTREPRISE_REQUEST, {
              nom: this.formCompany.nom,
              taux_commission: this.formCompany.taux_commission,
              url: this.formCompany.url,
              ville_id: this.formCompany.ville_id,
              civic: this.formCompany.civic,
              postal: this.formCompany.postal,
              rue: this.formCompany.rue,
              tel: this.formCompany.tel,
              email: this.formCompany.email,
              activite_id: this.formCompany.activite_id
            }).then(() => {
                $bus.$emit('app-notif', {
                show: true,
                text: 'L\'entreprise a été ajouté avec succès',
                color: 'success'
              })
            })
          }
        })
      },
      updateSearch (search) {
        this.search = search
      }
    },
    watch: {
      modal (opened) {
        if (opened) {
          this.loadingEntreprisesOptions = true
          this.$store.dispatch(GET_ENTREPRISE_CREATE).finally(() => {
            this.loadingEntreprisesOptions = false
          })
        }
      }
    }
  }
</script>
